/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

jQuery(document).ready(function ($) {
  // JS Trend Top Page
  //   $('.Trend__List').slick({
  //     infinite: true,
  //     speed: 300,
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     centerMode: true,
  //     variableWidth: true,
  //     draggable: true,
  //     dots: false,
  //     arrows: false
  //     autoplay: true
  //   });

  window.dragList = function (element) {
    var clicked = false,
      clickX
    var ele = $(element)
    var start = ele.scrollLeft()
    ele.on({
      mousemove: function (e) {
        clicked && updateScrollPos(e)
      },
      mousedown: function (e) {
        clicked = true
        clickX = e.clientX
        start = ele.scrollLeft()
      },
      mouseup: function (e) {
        clicked = false
        ele.css('cursor', 'grab')
      },
    })

    var updateScrollPos = function (e) {
      ele.css('cursor', 'grabbing')
      ele.scrollLeft(start + (clickX - e.clientX))
    }
  }

  // dragList('.Trend__List');

  window.dragList2 = function (element) {
    var clicked = false,
      clickX
    var ele = $(element)
    if (!ele.length) return
    var start = ele.css('left').replace('px', '') * 1
    var $next = ele.parent().parent().find('.slick-next')
    var $prev = ele.parent().parent().find('.slick-prev')

    //      console.log(offset);
    ele.on({
      mousemove: function (e) {
        clicked && updateScrollPos(e)
      },
      touchmove: function (e) {
        clicked && updateScrollPos(e)
      },
      pointerdown: function (e) {
        clicked = true
        clickX = e.clientX
        start = ele.css('left').replace('px', '') * 1
      },
    })

    $(document).on('pointerup', function () {
      clicked = false
      ele.css('cursor', 'grab')
    })

    $next.on('click', function () {
      var childWidth = ele.children().outerWidth()
      var left = ele.css('left').replace('px', '') * 1
      var value = checkValue(left - childWidth)
      ele.stop().animate(
        {
          left: value,
        },
        500
      )
    })
    $prev.on('click', function () {
      var childWidth = ele.children().outerWidth()
      var left = ele.css('left').replace('px', '') * 1
      var value = checkValue(left + childWidth)
      ele.stop().animate(
        {
          left: value,
        },
        500
      )
    })

    var updateScrollPos = function (e) {
      ele.css('cursor', 'grabbing')
      var clientX = e.touches ? e.touches[0].clientX : e.clientX
      //       console.log(start, clickX, clientX);

      var value = checkValue(start + (clientX - clickX))
      ele.css('left', value + 'px')
    }

    function checkValue(value) {
      var eleWidth =
        ele.outerWidth() -
        parseFloat(ele.css('padding-right').replace('px', ''))
      var childWidth = ele.children().length * ele.children().outerWidth()
      var widthChild = 0
      ele.children().each(function () {
        widthChild += $(this).outerWidth(true)
      })
      var offset = eleWidth - widthChild
      //  console.log(widthChild)
      //  console.log(eleWidth)

      if (value <= offset) {
        value = offset
        $next.addClass('slick-disabled')
      }
      if (value > offset && value < 0) {
        $next.removeClass('slick-disabled')
        $prev.removeClass('slick-disabled')
      }
      if (value >= 0) {
        value = 0
        $prev.addClass('slick-disabled')
      }
      return value
    }
  }

  dragList2('.CollectionListMenu__CarouselList')
  dragList2('.Trend__List')
  dragList2('.Product__SlideshowMobileNav')

  //     $('.CollectionListMenu__Carousel').slick({
  //       slidesToShow: 6,
  //       slidesToScroll: 1,
  //       infinite: false,
  //       arrows: true,
  //       dots: false,
  //       draggable: true,
  //       variableWidth: false,
  //       appendArrows: '.CollectionListMenu__Arrow',
  //       responsive: [
  //         {
  //           breakpoint: 769,
  //           settings: {
  //             slidesToShow: 3,
  //       		variableWidth: true
  //           }
  //         }
  //       ]
  //     });

  //    $('.CollectionList--carousel').slick();

  $(window).on('scroll', function () {
    let $touchPoint = $(window).scrollTop() + $(window).height()
    if ($touchPoint > $('#shopify-section-footer').offset().top) {
      $('#shopify-section-popup').addClass('c-hide')
      //         $('#shopify-section-popup').hide();
    } else {
      $('#shopify-section-popup').removeClass('c-hide')
      //         $('#shopify-section-popup').show();
    }
  })

  // siderbar filter collection
  //   $('.js-Collapsible__Button').click(function(){
  // 	$(this).toggleClass('is-active');
  // 	$(this).parent().find('.Collapsible__Inners').slideToggle();
  //   })

  // add to cart product page
  if ($('.template-product').length) {
    $('.Product__Variants .js-add-to-cart').on('click', function (e) {
      e.preventDefault()
      var quantity = 1
      var id = $(this).attr('data-id')
      $('input[name="id"]').val(id)
      setTimeout(function () {
        $('.Product__Variants').removeClass('is-show')
        $('.PageOverlay').removeClass('is-visible')
        $('html').removeClass('no-scroll')
      }, 500)
      //       return;
      //       var params = {
      //         type: 'POST',
      //         url: '/cart/add.js',
      //         async: false,
      //         data: 'quantity='+ quantity + '&id=' + id,
      //         dataType: 'json',
      //         success: function() {
      //           window.location = '/cart';
      //         },
      //         error: function(XMLHttpRequest, textStatus) {
      //           Shopify.onError(XMLHttpRequest, textStatus);
      //         }
      //       };
      //       jQuery.ajax(params);
    })

    //show modal variant on SP
    $('.js-showModalVariant').click(function () {
      $('.Product__Variants').addClass('is-show')
      $('.PageOverlay').addClass('is-visible')
      $('html').addClass('no-scroll')
    })
    $('.js-closeModalVariant').click(function () {
      $('.Product__Variants').removeClass('is-show')
      $('.PageOverlay').removeClass('is-visible')
      $('html').removeClass('no-scroll')
    })
  }

  //   window.onresize = function() {
  //     var instanceRecently = Flickity.data(document.querySelector('.shopify-section--recently-viewed-products .Carousel'));
  //     if(instanceRecently) {
  //       instanceRecently.deactivate();
  //       instanceRecently.activate();
  //     }

  //     var instanceRecommendations = Flickity.data(document.querySelector('.shopify-section--recommendations-products .Carousel'));
  //     if(instanceRecommendations) {
  //       instanceRecommendations.deactivate();
  //       instanceRecommendations.activate();
  //     }
  //   }

  window.addEventListener('resize', function (event) {
    document.querySelectorAll('.Carousel').forEach(function (item) {
      var instance = Flickity.data(item)
      if (instance) {
        instance.deactivate()
        instance.activate()
      }
    })
    //      var instanceRecently = Flickity.data(document.querySelector('.shopify-section--recently-viewed-products .Carousel'));
    //       if(instanceRecently) {
    //         instanceRecently.deactivate();
    //         instanceRecently.activate();
    //       }

    //       var instanceRecommendations = Flickity.data(document.querySelector('.shopify-section--recommendations-products .Carousel'));
    //       if(instanceRecommendations) {
    //         instanceRecommendations.deactivate();
    //         instanceRecommendations.activate();
    //       }

    //     	var instanceFeatured = Flickity.data(document.querySelector('.shopify-section--c-featured-collection .Carousel'));
    //         if(instanceFeatured) {
    //           instanceFeatured.deactivate();
    //           instanceFeatured.activate();
    //         }
  })

  // scroll toolbar collection
  if ($('.CollectionToolbar').length && $('.CollectionInner').length) {
    $(window).on('scroll', function () {
      if (
        $(window).scrollTop() + $('.CollectionToolbar').height() >
        $('.CollectionInner').offset().top
      ) {
        $('.CollectionToolbar--sticky').addClass('is-toolbar--scroll')
      } else {
        $('.CollectionToolbar--sticky').removeClass('is-toolbar--scroll')
      }
    })
  }
  // click dropdown filter
  try {
    FilterApi.afterCall = function (filter) {
      setTimeout(function () {
        if ($('.Popover__ValueList').length) {
          if ($('.CollectionToolbar__Item--sort').length) {
            $('.CollectionToolbar__Item--sort')
              .find('#SortSelected')
              .text(
                $(
                  '#collection-sort-popover .Popover__ValueList .Popover__Value.is-selected'
                ).text()
              )
          }
        }
        $('.Pagination__NavItem.Link').on('click', function () {
          $('html, body').animate(
            {
              scrollTop: $('.CollectionMain').offset().top - 100,
            },
            1000
          )
        })
      }, 0)

      if (filter.event_type == 'collection') {
        location.reload()
      }
      setTimeout(function () {
        if (
          $('.boost-pfs-filter-refine-by-items .refine-by-item').length == 0
        ) {
          $('.CollectionToolbar__Item button').css('font-weight', '300')
        }
      }, 0)
    }
    FilterApi.beforeCall = function () {
      $('.CollectionToolbar__Item button').css('font-weight', 'bold')
    }
  } catch (err) {
    //console.log(err);
  }

  // add wishlist variant
  function sendTracking(event, product, action) {
    if (typeof fbq === 'function') {
      switch (event.eventAction) {
        case 'WK Added Product':
          fbq('track', 'AddToWishlist', {
            value: product.price,
            currency: 'JPY',
          })
          break
      }
    }
    if (typeof ga === 'function') {
      if (product) {
        delete product.price
        ga('ec:addProduct', product)
      }

      if (action) {
        ga('ec:setAction', 'click', action)
      }

      if (event) {
        ga('send', event)
      }

      if (!ga.loaded) {
        event && event.hitCallback && event.hitCallback()
      }
    } else {
      event && event.hitCallback && event.hitCallback()
    }
  }

  $('.btn-variants-wishlist').click(function () {
    var productId = this.getAttribute('data-product-id')
    var variantId = this.getAttribute('data-variant-id')

    if ($(this).hasClass('add-wishlist')) {
      Wishlist.removeProduct(productId, variantId)
      $(this).removeClass('add-wishlist')
    } else {
      Wishlist.addProduct(productId, variantId)
      $(this).addClass('add-wishlist')
      
      window.dataLayer.push({
        event: 'add_to_wishlist',
        item: {
          item_id: productId,
          variant_id: variantId
        }
      })
    }
    window.SixtyPercentApiWebClient.fetchProduct(productId).then((product) => {
      const favoriteCount = product.favoriteCount
      favoriteCountElement = document.getElementById('product-favorit-count');
      if (favoriteCount > 49) {
        favoriteCountElement.textContent = String(favoriteCount);
        favoriteCountElement.parentElement.classList.add('wk-iconPosition_fixBottom')
      }
      if ($('#product-variants').find('.add-wishlist').length > 0) {
        favoriteIconElement = document.getElementById('product-favorit-icon');
        if (!favoriteIconElement.classList.contains('Product__FavoritIcon_Active')) {
          favoriteIconElement.classList.add('Product__FavoritIcon_Active')
          favoriteCountElement.classList.add('Product__FavoritCount_Active')
        }
      } else if ($('#product-variants').find('.add-wishlist').length < 1) {
        favoriteIconElement = document.getElementById('product-favorit-icon');
        if (favoriteIconElement.classList.contains('Product__FavoritIcon_Active')) {
          favoriteIconElement.classList.remove('Product__FavoritIcon_Active')
          favoriteCountElement.classList.remove('Product__FavoritCount_Active')
        }
      }
      favoriteCountElement.parentElement.classList.add('Product__Favorit_Active')

      document.querySelectorAll('.btn-variants-wishlist').forEach(element => {
        const variant = product.variants.find(variant => variant.id == element.getAttribute('data-variant-id'));
        if (variant.favoritedByCurrentCustomer) {
          element.classList.add('add-wishlist');
        }
      });
    })
  })

  if ($('.template-product').length > -1) {
    $('.c-variant-content .c-variant-tab').each(function (index) {
      var indexs = index + 1
      if (indexs == 5 || indexs < 5) {
        $('.c-variant-content .Collapsible__Button').attr(
          'aria-expanded',
          'true'
        )
        $('.c-variant-content .Collapsible__Inner').css('height', 'auto')
      } else {
        $('.c-variant-content .Collapsible__Button').attr(
          'aria-expanded',
          'false'
        )
        $('.c-variant-content .Collapsible__Inner').css('height', '0')
      }
    })
  }

  if ($('.template-page').length) {
    $('.CollectionList .slick-slide').each(function () {
      var foreignCharacters = $(this).find('.SectionHeader__Heading').text()
      var rforeign =
        /[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf]/
      if (rforeign.test(foreignCharacters)) {
        $(this).find('.SectionHeader__Heading').addClass('u-jpText')
      }
    })
  }

  //    $(window).scroll(function(){
  //      if ($(window).scrollTop() >= 37) {
  //        $('.shopify-section--header').addClass('fixed-header');
  //      }
  //      else {
  //        $('.shopify-section--header').removeClass('fixed-header');
  //      }
  //    });

  function setTop() {
    if (BoostPFS.instance) {
      BoostPFS.instance.search.children.map(function (ele) {
        ele.instantSearchResult._setSuggestionPosition()
      })
    }
  }
  //console.log($( "form[action='/search'] input" ))
  $("form[action='/search'] input").on('focus', function () {
    //console.log('asfas')
    //      var self = this;
    //     setTimeout(setTop, 100);
    //     setTimeout(setTop, 500);
    //     setTimeout(setTop, 1000);
    //     setTimeout(setTop, 1500);
  })

  //    var checkExitsoldOut = setInterval(function() {

  //      var $item = $('.ProductItem__Info .ProductItem__Label--soldOut');
  //      if ($item.length) {
  //        clearInterval(checkExitsoldOut);
  //        $('.shopify-section .ProductListWrapper .Carousel__Cell').each(function(){
  //          var $this = $(this);
  //          if($this.find('.ProductItem__Info .ProductItem__Label--soldOut').html() == 'Sold'){
  //            $this.parents('Section').addClass('pr-soldOut');
  //            var heightVendor = $this.find('.ProductItem__Info .ProductItem__Vendor').height();
  //            if(heightVendor > 20){
  //              $this.parents('Section').addClass('pr-soldOutPd');
  //            }
  //          }
  //        });
  //      }

  //    }, 100); // check every 100ms

  //    var $item = $('.ProductItem__Info .ProductItem__Label--soldOut');
  //      if ($item.length) {
  //        $('.shopify-section .ProductListWrapper .Carousel__Cell').each(function(){
  //          var $this = $(this);
  //          if($this.find('.ProductItem__Info .ProductItem__Label--soldOut').html() == 'Sold'){
  //            $this.parents('Section').addClass('pr-soldOut');
  //            var heightVendor = $this.find('.ProductItem__Info .ProductItem__Vendor').height();
  //            if(heightVendor > 20){
  //              $this.parents('Section').addClass('pr-soldOutPd');
  //            }
  //          }
  //        });
  //      }

  var checkExitsoldOutRelated = setInterval(function () {
    var $section = $('.RelatedProduct')
    if ($section.length < 1) clearInterval(checkExitsoldOutRelated);

    var $item = $('.RelatedProduct .ProductItem__Info .ProductItem__Label')
    if ($item.length) {
      clearInterval(checkExitsoldOutRelated)
      $('.RelatedProduct .ProductListWrapper .Carousel__Cell').each(
        function () {
          var $this = $(this)

          if ($this.find('.ProductItem__Info .ProductItem__Label').length > 0) {
            $this.parents('Section').addClass('pr-soldOut')
            console.log('ok')
            var heightVendor = $this
              .find('.ProductItem__Info .ProductItem__Vendor')
              .height()
            if (heightVendor > 20) {
              $this.parents('Section').addClass('pr-soldOutPd')
            }
          }
        }
      )
    }
  }, 100) // check every 100ms
})
